import {Box, Flex, HStack, VisuallyHidden, Link} from '@chakra-ui/react';
import {Link as RouterLink} from 'react-router-dom';
import * as React from 'react';
import {Logo} from './Logo';
import HMMenu from './menu';

const Header = () => {
    const isActive = false;
    return (
        <>
            <Box as="header" borderBottomWidth="1px" borderColor={'brandAlpha.200'}>
                <Box px={['5', '10']}>
                    <Box
                        borderX={'1px'}
                        borderColor={'brandAlpha.200'}
                        pt="6"
                        pb={'0.625rem'}
                        px={['2.5', '5']}
                    >
                        <Flex as="nav" justify="space-between">
                            <HStack spacing="8">
                                <Link
                                    as={RouterLink}
                                    to="/"
                                >
                                    <VisuallyHidden>Venrock</VisuallyHidden>
                                    <Logo/>
                                </Link>
                            </HStack>
                            <Flex align="center">
                                <HStack display={'flex'} spacing="8" color="brand.600">
                                    <Link
                                        as={RouterLink}
                                        display={{base: 'none', md: 'flex'}}
                                        to="/team"
                                        style={{
                                            textDecoration: isActive ? 'underline' : undefined,
                                            fontSize: '12px',
                                            textColor: 'brand.600',
                                            _focus: {
                                                boxShadow: 'none',
                                                textDecoration: 'underline',
                                            },
                                        }}
                                    >
                                        People
                                    </Link>
                                    <HMMenu/>
                                </HStack>
                            </Flex>
                        </Flex>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default Header;

Header.displayName = 'companies-overview__Header';
